import React, { useState, useEffect } from 'react'
import { Icon, Panel, Placeholder } from 'rsuite'
import ReactECharts from 'echarts-for-react'
import { CHART_THEME } from '../../../constants/project'
import { cloneDeep } from 'lodash-es'
import { getSummaryOfRisk } from '../../../redux/actions/auditDashboard'

export default function SummaryOfRiskChart({ request, shaded }) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [chartOption, setChartOption] = useState()
  const [categoryDetails, setCategoryDetails] = useState()
  const [showDetail, setShowDetail] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [request])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      const response = await getSummaryOfRisk(request)
      // const response = mockSchema

      setCategoryDetails(response.categoryDetails)
      let charts = cloneDeep(chartSchema)

      let seriesDatas = []
      response?.chartDatas.forEach((e) => {
        let seriesData = cloneDeep(seriesDataSchema)

        seriesData.name = e.name
        seriesData.data = e.value

        seriesDatas.push(seriesData)
      })

      charts.title.text = response?.chartTitle
      charts.xAxis.data = response?.category || []
      charts.series = seriesDatas

      // console.log('SummaryOfDepartmentChart : ', JSON.stringify(charts))

      setSchema(response)
      setChartOption(charts)
    } catch (e) {
      console.log('error ', e)
      // setError({})
    }
    setIsLoading(false)
  }

  return (
    <>
      {schema && (
        <Panel
          collapsible
          defaultExpanded
          header={schema.header}
          bordered
          style={{ marginTop: 20 }}
          shaded={shaded}
        >
          {isLoading && <Placeholder.Graph active />}

          {categoryDetails && (
            <>
              <div
                style={{ marginBottom: 10, cursor: 'pointer', color: '#2da888' }}
                onClick={() => {
                  setShowDetail(!showDetail)
                }}
              >
                {/* <ViewButton /> */}

                <Icon icon="info-circle" size="2x" />
                <span style={{ marginLeft: 10 }}>
                  {showDetail ? 'ซ่อน' : 'ดู'}คำอธิบายเพิ่มเติม
                </span>
              </div>

              {showDetail && (
                <>
                  <Panel header="ประเด็น" collapsible defaultExpanded>
                    <div style={{ marginTop: -10 }}>
                      {categoryDetails.map((e) => {
                        return (
                          <div style={{ marginLeft: 20 }}>
                            <b>{`${e.name}`}</b>
                            {e.subs?.map((se) => {
                              return (
                                <div style={{ marginLeft: 20 }}>{`${se.code} = ${se.name}`}</div>
                              )
                            })}
                          </div>
                        )
                      })}
                    </div>
                  </Panel>
                </>
              )}
            </>
          )}

          {chartOption && (
            <ReactECharts
              theme={CHART_THEME}
              option={chartOption}
              style={{ minHeight: '440px', width: '100%' }}
              className={'react_for_echarts'}
            />
          )}
        </Panel>
      )}
    </>
  )
}

const seriesDataSchema = {
  name: '',
  type: 'bar',
  data: [],
  stack: 'total',
  label: {
    show: true,
  },
  emphasis: {
    focus: 'series',
  },
}
const colors = [
  '#2ec7c9',
  '#b6a2de',
  '#5ab1ef',
  '#ffb980',
  '#d87a80',
  '#8d98b3',
  '#e5cf0d',
  '#97b552',
  '#95706d',
  '#dc69aa',
  '#07a2a4',
  '#9a7fd1',
  '#588dd5',
  '#f5994e',
  '#c05050',
  '#59678c',
  '#c9ab00',
  '#7eb00a',
  '#6f5553',
  '#c14089',
  // --- เพิ่มเติมอีก 10 สี ---
  '#4ecda4',
  '#f7a35c',
  '#90ed7d',
  '#f15c80',
  '#e4d354',
  '#8085e9',
  '#8d4653',
  '#91e8e1',
  '#f45b5b',
  '#7cb5ec',
]
const chartSchema = {
  title: {
    text: '',
    subtext: '',
    left: 'left',
    top: '10',
    textStyle: {
      color: '#008acd',
      opacity: '0.7',
      fontWeight: '400',
      fontSize: '1rem',
    },
  },
  color: colors,
  tooltip: {},
  toolbox: {
    show: true,
    feature: {
      saveAsImage: { show: true, title: 'บันทึกเป็นรูป' },
    },
  },
  legend: {
    top: '40',
    left: 'center',
  },
  grid: {
    left: '3%',
    right: '3%',
    top: '80',
    bottom: '50',
    containLabel: true,
  },
  xAxis: { type: 'category', data: [] },
  yAxis: {
    type: 'value',
    boundaryGap: [0, 0.01],
  },
  series: [],
}

// const seriesDataSchema = {
//   name: '',
//   type: 'bar',
//   data: [],
//   // itemStyle: { normal: { color: '#63c2ff' } },
//   // itemStyle: { normal: { color: '#dd8b90' } },
//   // itemStyle: { normal: { color: '#ffc184' } },
//   // itemStyle: { normal: { color: '#41b596' } },
// }

// const colors = ['#63c2ff', '#dd8b90', '#ffc184', '#41b596']
// const chartSchema = {
//   title: {
//     text: '',
//     subtext: '',
//     left: 'left',
//     top: '10',
//     textStyle: {
//       color: '#008acd',
//       opacity: '0.7',
//       fontWeight: '400',
//       fontSize: '1rem',
//     },
//   },
//   color: colors,
//   tooltip: {
//     trigger: 'axis',
//     axisPointer: {
//       type: 'shadow',
//     },
//   },
//   toolbox: {
//     show: true,
//     feature: {
//       //dataView: { show: true, readOnly: false },
//       saveAsImage: { show: true, title: 'บันทึกเป็นรูป' },
//     },
//   },
//   legend: {
//     top: '40',
//     left: 'center',
//   },
//   grid: {
//     left: '3%',
//     right: '3%',
//     top: '80',
//     bottom: '50',
//     containLabel: true,
//   },
//   xAxis: {
//     type: 'category',
//     data: [],
//   },
//   yAxis: {
//     type: 'value',
//     boundaryGap: [0, 0.01],
//   },
//   dataZoom: [
//     {
//       type: 'slider',
//       show: true,
//       xAxisIndex: 0,
//       // yAxisIndex: [0, 1],
//       // start: 1,
//       // end: 100,
//     },
//     {
//       type: 'inside',
//       xAxisIndex: 0,
//       // yAxisIndex: [0, 1],
//       // start: 1,
//       // end: 35,
//     },
//   ],
//   series: [],
// }
